import React, { useRef } from 'react';
import { Trans } from 'react-i18next';
import Slider from 'react-slick';

import { maleWorkoutTargetAreas } from 'constants/workouts/workouts';

import isMobile from 'helpers/isMobile';

import * as S from './styled';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

interface TargetAreaSliderProps {
    stateAreas: string | string[];
    handleButtonClick: (value: React.MouseEvent<HTMLButtonElement>) => void;
    targetAreas: typeof maleWorkoutTargetAreas;
}

const TargetAreasSlider = ({ stateAreas, handleButtonClick, targetAreas }: TargetAreaSliderProps) => {
    const areasEntries = Object.entries(targetAreas);
    const sliderWidth = 340;
    const paddingBtwSlides = 12;

    const isActive = (name: string) => {
        return stateAreas.includes(name);
    };

    const sliderRef = useRef<Slider>(null);

    const settings = {
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        swipe: isMobile.any() ? true : false,
        arrows: false,
        pauseOnHover: false,
    };

    return (
        <S.Slider ref={sliderRef} {...settings} sliderWidth={sliderWidth} paddingBtwSlides={paddingBtwSlides}>
            {areasEntries.map(([key, area]) => {
                const isActiveArea = isActive(key);

                return (
                    <S.TargetAreaWrapper
                        key={key}
                        onClick={handleButtonClick}
                        value={key}
                        name="areas"
                        data-testid={`target-area-${key}`}
                    >
                        <S.TargetArea $isActive={isActiveArea} />
                        <S.TargetAreaImg $isActive={isActiveArea} maxWidth={104} src={area.img} alt={area.title} />
                        <S.TargetAreaTitle $isActive={isActiveArea} type="caption" center>
                            <Trans i18nKey={area.title} />
                        </S.TargetAreaTitle>
                    </S.TargetAreaWrapper>
                );
            })}
        </S.Slider>
    );
};

export default TargetAreasSlider;
